import React, {Component} from 'react'

import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {strings,CCActivityIndicator,CCNotificationItem,DataActionTypes as DataAT,CCActions} from './../../cc-imports'

import {Constants, CCUIUtils} from "../../cc-imports";
import PropTypes from 'prop-types';
import CCListView from "../../components/CCListView/CCListView2";
import './../../styles/css/screens/Notifications/notifications.css'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";
class Notifications extends Component {

    static propTypes = {
        claimPressed : PropTypes.func
    }

    static defaultProps = {
        claimPressed:()=>{}
    }

    constructor(props) {
        super(props);

        this.state = {
            skip : 0,
            screen:'ntfns',
            claimNtfn : {},
            reqPending : false
        }

        this._fetchNotifications=this._fetchNotifications.bind(this);
        this._autoRefresh=this._autoRefresh.bind(this);
        this._manualRefresh=this._manualRefresh.bind(this);
        this._paginate=this._paginate.bind(this);
        this._claimPressed=this._claimPressed.bind(this);
    }

    _fetchNotifications(type) {
        if(this.state.reqPending==true) return;
        const {userId, actions, pages} = this.props;
        this.setState({reqPending : true},()=>{

            var page = pages[userId] == undefined ? 0 : pages[userId];
            var skip = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? 0 : page;
            var limit = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? page * 20 : 20;

            if (userId) {
                actions.fetchNotifications(userId, skip, limit, type).then(()=>{
                    this.setState({reqPending : false});
                }).catch(()=>{
                    this.setState({reqPending : false});
                })
            }
        })
    }


    _autoRefresh(){
        this._fetchNotifications(DataAT.AUTO_REFRESH);
    }

    _manualRefresh() {
        this._fetchNotifications(DataAT.MANUAL_REFRESH);
    }

    _paginate() {
        const {reqStatus} = this.props;
        if (reqStatus != Constants.reqStatus.FAI && reqStatus != Constants.reqStatus.COM) {
            this._fetchNotifications(DataAT.PAGINATE);
        }
    }


    _closeModal() {
        this.props.actions.closeModal("Notifications");
    }


    componentWillReceiveProps(nextProps) {

    }


    _claimPressed(claimNtfn) {
        const {claimPressed} = this.props;
        claimPressed({claimNtfn});
    }

    componentDidMount() {
        if (this.props.userId) {
            this._fetchNotifications(DataAT.GET);
        }
    }


    render() {
        const {reqStatus, type, byId, byUserId, userId} = this.props
        const {screen} = this.state;


        var ntfns = byUserId[userId] ? byUserId[userId] : [];

        return (
            <CCErrorBoundary>
            <div className={"flex-container"} style={{flex: 1, flexDirection:'column'}}>
                <div className="flex-container" style={{alignItems: 'center', justifyContent: 'center', marginBottom: 10, marginTop: 10}}>
                    <h1 className="notification-title"> {strings('notifications')}</h1>
                </div>
                {
                    (ntfns && ntfns.length > 0) ?
                        <CCListView data={ntfns} onEndReachedThreshold={2} onEndReached={this._paginate}
                                    endReached={reqStatus == Constants.reqStatus.COM || reqStatus == Constants.reqStatus.FAI}
                                    renderItem={(ntfnId) => {
                                        const ntfn = byId[ntfnId];
                                        return (<CCNotificationItem userId={userId} onClaim={() => {
                                            this._claimPressed(ntfn)
                                        }} notification={ntfn} key={ntfn.id}></CCNotificationItem>)
                                    }}/>
                        :
                        CCUIUtils.getEmptyListItem(reqStatus)
                }
            </div>
            </CCErrorBoundary>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user,
        byId: state.notifications.byId,
        byUserId: state.notifications.byUserId,

        pages: state.notifications.pages,
        userId: state.user.user.id,
        random: state.notifications.random,
        type: state.notifications.type,
        reqStatus: state.notifications.reqStatus
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(Notifications);


// WEBPACK FOOTER //
// ./src/app/screens/Notifications/Notifications.js